import { render, staticRenderFns } from "./MultipleChoiceV1Properties.vue?vue&type=template&id=1320dfe2&"
import script from "./MultipleChoiceV1Properties.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports